export type SupportedChangelogLocale = "en" | "de"

export interface ChangelogPage {
  title: Record<SupportedChangelogLocale, string>
  description?: Record<SupportedChangelogLocale, string>
  changes?: Record<SupportedChangelogLocale, string[]>
  thumbnail?: string
}

export interface ChangelogEntry {
  version: string
  publishedAt: Record<SupportedChangelogLocale, string>
  pages: ChangelogPage[]
}

// Keep newest entry first. The first entry is what users see after an update.
export const CHANGELOG_ENTRIES: ChangelogEntry[] = [
  {
    "version": "0.13.0",
    "publishedAt": {
      "en": "March 31, 2026",
      "de": "31. März 2026"
    },
    "pages": [
      {
        "title": {
          "en": "Sign-In with Apple functionality",
          "de": "Anmelden mit Apple Funktionalität"
        },
        "description": {
          "en": "This update introduces the long-awaited Sign-In with Apple feature, allowing users to easily create accounts and sign in using their Apple ID. Alongside this, we've implemented significant performance optimizations to enhance the overall user experience.",
          "de": "Dieses Update führt die lang ersehnte Funktion 'Anmelden mit Apple' ein, die es den Nutzern ermöglicht, einfach Konten zu erstellen und sich mit ihrer Apple-ID anzumelden. Zusätzlich haben wir signifikante Performance-Optimierungen implementiert, um die Benutzererfahrung insgesamt zu verbessern."
        }
      },
      {
        "title": {
          "en": "Sign in with Apple functionality",
          "de": "Anmelden mit Apple Funktionalität"
        },
        "changes": {
          "en": [
            "Added Sign-In with Apple functionality for seamless account creation and login.",
            "Implemented secure authentication flows and error handling for Apple Sign-In.",
            "Enhanced user experience with smooth transitions and feedback during the sign-in process."
          ],
          "de": [
            "Funktion 'Anmelden mit Apple' hinzugefügt für nahtlose Kontoerstellung und Anmeldung.",
            "Sichere Authentifizierungsabläufe und Fehlerbehandlung für Apple Sign-In implementiert.",
            "Verbesserte Benutzererfahrung mit reibungslosen Übergängen und Feedback während des Anmeldevorgangs."
          ]
        }
      },
      {
        "title": {
          "en": "Bug Fixes",
          "de": "Fehlerbehebungen"
        },
        "changes": {
          "en": [
            "Fixed overlapping tasks in the calendar day and week views.",
            "Resolved hydration and SSR issues for a smoother app start.",
            "Fixed task modals staying open after creation in specific views.",
            "Updated German localization.",
            "Corrected pricing section."
          ],
          "de": [
            "Überlappende Aufgaben in der Tages- und Wochenansicht des Kalenders behoben.",
            "Hydration- und SSR-Probleme für einen flüssigeren App-Start gelöst.",
            "Aufgaben-Modals schließen nun korrekt nach der Erstellung.",
            "Deutsche Lokalisierung aktualisiert.",
            "Preise-Seite korrigiert."
          ]
        }
      }
    ]
  }
]

export const LATEST_CHANGELOG_ENTRY = CHANGELOG_ENTRIES[0]

export function resolveChangelogLocale(locale: string): SupportedChangelogLocale {
  return locale.startsWith("de") ? "de" : "en"
}
